// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CellEditController from "./cell_edit_controller"
application.register("cell-edit", CellEditController)

import SaveAllController from "./save_all_controller"
application.register("save-all", SaveAllController)

import RowEditController from "./row_edit_controller"
application.register("row-edit", RowEditController)
